<template>
  <div class="cabecera-detalle">
    <strong>&Iacute;tems pedido</strong>
    <table v-if="subpedidos" class="table is-bordered is-narrow is-fullwidth">
      <thead>
        <th width="3%"><b-icon icon="hashtag"></b-icon></th>
        <th width="7%">C&oacute;digo</th>
        <th width="33%">Descripci&oacute;n</th>
        <th width="6%">U.M.</th>
        <th width="6%">Stock</th>
        <th width="6%">Solicitado</th>
        <th width="6%">Facturado</th>
        <th width="6%">Pickeado</th>
        <th width="6%">Pendiente</th>
        <th width="12%">Entregado</th>
        <th v-if="!esUsuarioMonitor" width="3%" class="has-text-centered">
          <b-icon icon="user-check"></b-icon>
        </th>
      </thead>
      <cierre-detalle-grupo
        v-for="(pedido, index) in subpedidos"
        :key="`detalle-grupo-${pedido.id}-${index}`"
        :pedido="pedido"
        :color="getColor(index)"
        :es-grupo-actual="esGrupoActual(pedido.id)"
        @next-group="changeGroupFocusHandle"
      ></cierre-detalle-grupo>
    </table>
  </div>
</template>

<script>
import CierreDetalleGrupo from '@/components/cierre/CierreDetalleGrupo.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'CierreDetalle',
  components: {
    CierreDetalleGrupo
  },
  data() {
    return {
      colores: [],
      pedidoActual: 0,
      pedidoInicializado: false
    }
  },
  computed: {
    ...mapGetters('sesion', ['bodega']),
    ...mapGetters('despacho', ['pedidos']),
    subpedidos() {
      const pedidosFiltrados =
        this.pedidos.length === 1
          ? this.pedidos
          : this.pedidos.filter((item, index) => index > 0)

      return pedidosFiltrados.filter((pedido) =>
        pedido.items.some((item) => item.esKit || item.pedidoItemKitId == null)
      )
    },
    esUsuarioMonitor() {
      // Si usuario tiene rol Monitor, no se muestran acciones
      return this.bodega.roles.some((rol) => rol.id === 6)
    }
  },
  watch: {
    subpedidos() {
      if (this.subpedidos && !this.pedidoInicializado) {
        this.pedidoActual = this.subpedidos[0].id
      }
    }
  },
  created() {
    const colors = [
      '#C0E4F1',
      '#F3EACE',
      '#F6F6F6',
      '#E7F1D4',
      '#AFD6F7',
      '#C2DEDF'
    ]
    for (let i = colors.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1))
      ;[colors[i], colors[j]] = [colors[j], colors[i]]
    }
    this.colores = colors
  },
  methods: {
    esGrupoActual(id) {
      return this.pedidoActual === id
    },
    getColor(index = 0) {
      return this.colores[index % this.colores.length]
    },
    changeGroupFocusHandle(payload) {
      let index = this.pedidos.findIndex((item) => item.id === payload) + 1
      if (index >= this.pedidos.length) {
        index = 0
      }
      this.pedidoActual = this.pedidos[index].id
    }
  }
}
</script>

<style lang="scss" scoped>
.botonera {
  margin-bottom: 0.5em;
}

.cabecera-detalle {
  margin-top: 15px;
  margin-bottom: 20px;
}
</style>
